import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/footer.css';

const Logo = () => (
  <img
    src="/Logo1.png"
    alt="The Elite Global Review"
    className="footer-logo"
    width="240"
    height="42"
  />
);

const QUICK_LINKS = [
  { label: 'The Elite Global Review', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Press Release', to: '/category/press-release' },
  { label: 'Magazine', to: '/magazine' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Editorial Policy ', to: '/editorial-policy' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'Advertise With Us', to: '/advertise' },
];

const CONTACT_INFO = [
  { label: 'Dublin, OH', value: '+1 478 276 4136', href: 'tel:+14782764136' },
  { label: 'Dubai, UAE', value: '+971 5618 800 49', href: 'tel:+971561880049' },
  { label: 'Pune, India', value: '+91 7410033803', href: 'tel:+917410033803' },
];

const RECENT_POSTS = [
  {
  label: 'AI Virtual: How Founder Hamid Kohan Is Transforming Business Productivity Through AI',
  to: '/article/AI_Virtual',
},
  {
    label: 'The Most Influential Healthcare Advocate & Author to Watch in 2026',
    to: '/article/Jennifer_White',
  },
  {
    label: 'Dana Hatch — Founder of The Unfiltered Method',
    to: '/article/Dana_Hatch',
  },
  // {
  //   label: 'How Performance-Driven Leadership Builds High-Performing Organizations',
  //   to: '/how-performance-driven-leadership-builds-high-performing-organizations',
  // },
];

const SOCIALS = [
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com',
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/the_elite_global_review/',
    icon: (
      <svg width="16" height="16" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: 'X',
    href: 'https://x.com',
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18.9 2H22l-7.6 8.7L23.3 22h-6.9l-5.4-6.9L4.8 22H1.6l8.1-9.3L1 2h7.1l4.9 6.3L18.9 2zm-1.2 18h1.9L7.4 4H5.4l12.3 16z" />
      </svg>
    ),
  },
  {
    label: 'Medium',
    href: 'https://medium.com',
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13.54 12a6.72 6.72 0 0 1-6.72 6.72A6.72 6.72 0 0 1 .1 12a6.72 6.72 0 0 1 6.72-6.72A6.72 6.72 0 0 1 13.54 12zm7.42 0c0 3.54-1.5 6.42-3.36 6.42-1.85 0-3.35-2.88-3.35-6.42s1.5-6.42 3.35-6.42c1.85 0 3.36 2.87 3.36 6.42zm3.04 0c0 3.17-.53 5.75-1.18 5.75-.65 0-1.18-2.57-1.18-5.75s.53-5.75 1.18-5.75c.65 0 1.18 2.57 1.18 5.75z" />
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com',
    icon: (
      <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.68 0H1.32C.59 0 0 .59 0 1.32v21.36C0 23.41.59 24 1.32 24h11.5v-9.29H9.69v-3.62h3.13V8.41c0-3.1 1.89-4.79 4.66-4.79 1.32 0 2.46.1 2.79.14v3.24h-1.92c-1.5 0-1.79.72-1.79 1.76v2.31h3.59l-.47 3.62h-3.12V24h6.12c.73 0 1.32-.59 1.32-1.32V1.32C24 .59 23.41 0 22.68 0z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const [open, setOpen] = useState(true);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      setStatus('error');
      return;
    }

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          access_key: '5bd1a50d-901d-48a6-ba74-116fa5dbbe25',
          name: form.name,
          email: form.email,
          message: form.message,
          subject: 'New Get in Touch Submission - The Elite Global Review',
          from_name: 'The Elite Global Review',
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="subscribe" className="site-footer" role="contentinfo">
      {/* Top panel: brand + get in touch form */}
      <div className="footer-top-panel">
        <div className="wrap footer-top-grid">
          <div className="footer-brand">
            <Link to="/" aria-label="Home"><Logo /></Link>
            <p className="footer-desc">
              The Elite Global Review is a premium business magazine and media platform showcasing influential leaders, entrepreneurs, innovators, and the stories, insights, and ideas shaping the future of global business.
            </p>
          </div>

          <div className="footer-touch">
            <p className="footer-touch-intro">
              Whether you need expert business insights, strategic branding solutions,
              or media partnerships, we are here to help.
            </p>

            <button
              type="button"
              className={`touch-toggle ${open ? 'is-open' : ''}`}
              onClick={() => setOpen((o) => !o)}
              aria-expanded={open}
            >
              Get in Touch
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
              </svg>
            </button>

            {open && (
              <form className="touch-form" onSubmit={handleSubmit}>
                <div className="touch-form-row">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={form.name}
                    onChange={handleChange}
                    aria-label="Your Name"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={form.email}
                    onChange={handleChange}
                    aria-label="Your Email"
                  />
                </div>

                <textarea
                  name="message"
                  className="touch-message"
                  placeholder="Your Message"
                  value={form.message}
                  onChange={handleChange}
                  aria-label="Your Message"
                  rows={3}
                />

                <button type="submit" className="touch-submit">Submit</button>
                {status === 'success' && (
                  <p className="touch-status touch-status-success">Thanks! We&apos;ll be in touch.</p>
                )}
                {status === 'error' && (
                  <p className="touch-status touch-status-error">Please fill in all fields.</p>
                )}
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Main grid */}
      <div className="footer-main">
        <div className="wrap footer-grid">

          <div className="fcol">
            <h4 className="fcol-title">Quick Links</h4>
            <ul>
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="fcol">
            {/* <h4 className="fcol-title">Contact Info</h4> */}
            <ul className="fcontact-list">
              {/* {CONTACT_INFO.map((c) => (
                <li key={c.label}>
                  {c.label} :{' '}
                  <a href={c.href}>{c.value}</a>
                </li>
              ))} */}
            </ul>

            <h4 className="fcol-title fcol-title-social fcol2">Follow Us</h4>
            <div className="footer-social">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="social-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${s.label}`}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="fcol">
            <h4 className="fcol-title">Recent Posts</h4>
            <ul>
              {RECENT_POSTS.map((post) => (
                <li key={post.label}>
                  <Link to={post.to}>{post.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="wrap footer-bottom-inner">
          <p>
            &copy; Copyright {new Date().getFullYear()}, The Elite Global Review | All Rights Reserved.
          </p>
          <button
            className="to-top"
            onClick={scrollToTop}
            aria-label="Back to top"
            title="Back to top"
          >
            <svg
              width="20"
              height="20"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2.5"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}